
import { propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { envConfig } from "../lib/constants";

const Props = propsInstance<{
  childBackground?: boolean;
}>({
  childBackground: { type: Boolean, required: false, default: false },
});

@Component({
  name: "SafeArea",
})
export default class SafeArea extends mixins(MixedVue, Props) {
  $refs: {
    safeArea: HTMLDivElement;
  };

  background: string = null;
  emulateSwipeBar = envConfig.VUE_APP_EMULATE_SWIPE_BAR === "true";

  mounted() {
    if (this.childBackground) {
      const child = this.$refs.safeArea.firstElementChild;
      if (child) {
        this.background = getComputedStyle(child).background;
      }
    }
  }

  public getInset() {
    const style = getComputedStyle(this.$refs.safeArea);
    return {
      top: parseInt(style.paddingTop),
      right: parseInt(style.paddingRight),
      bottom: parseInt(style.paddingBottom),
      left: parseInt(style.paddingLeft),
    };
  }
}
